import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceIntern {
    lookupService = new APIServiceLookUp();

    async getAllIntern(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}intern/getAllIntern`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setIntern(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}intern/setIntern`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateIntern(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}intern/updateIntern`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delIntern(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}intern/delIntern`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
